import React from 'react';
import moment from 'moment';

import ForumPost from './ForumPost';
import ForumItem from './ForumItem';

import '../../css/Forum.css';

class Forum extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			posts: [],
			canGetMoreMessages: true,
			timeSinceStart: 0,
			deleteLoading: true,
		};

		this.addPost = this.addPost.bind(this);
		this.getPosts = this.getPosts.bind(this);
		this.onDeleteAnswer = this.onDeleteAnswer.bind(this);
		this.onDeletePost = this.onDeletePost.bind(this);
		this.onNewAnswer = this.onNewAnswer.bind(this);
		this.onNewPost = this.onNewPost.bind(this);
		this.onReaction = this.onReaction.bind(this);

		this.listener = () => {};
		this.lastVisible = null;

		this.timesInterval = null;
	}
	componentDidMount() {
		if (this.props.event_id) {
			this.getPosts();
			this.timesInterval = setInterval(this.updateTimes, 120000);
		}
	}
	componentWillUnmount() {
		this.listener();
		clearInterval(this.timesInterval);
	}
	componentDidUpdate(nP, nS) {
		if (nP.event_id !== this.props.event_id) {
			this.getPosts();
		}
	}
	updateTimes = () => {
		this.setState({ timeSinceStart: moment().unix() });
	};
	getPosts() {
		const self = this;
		const _arr = this.state.posts;

		let query = (this.chatListener = this.props.firebase.db
			.collection('forums')
			.doc(this.props.event_id)
			.collection('posts')
			.orderBy('timestamp', 'desc'));

		if (_arr.length > 0) {
			if (this.lastVisible) {
				query = query.startAfter(this.lastVisible);
			}
		}

		this.listener = query.limit(15).onSnapshot((docs) => {
			if (docs.docs.length === 0) {
				self.setState({ canGetMoreMessages: false });
			}
			this.lastVisible = docs.docs[docs.docs.length - 1];
			let needChange = false;
			docs.docChanges().forEach(function (change) {
				if (change.type === 'added') {
					needChange = true;

					const post = change.doc.data();

					if (post.timestamp) {
						if (post.timestamp.seconds) {
							post.timestamp = post.timestamp.seconds;
						}
					} else {
						post.timestamp = moment(post.date, 'YYYY-MM-DD HH:mm:ss Z').unix();
					}

					_arr.push({
						id: change.doc.id,
						author: post.author,
						author_name: post.author_name,
						photoURL: post.photoURL,
						likes: post.likes,
						dislikes: post.dislikes,
						date: post.date,
						message: post.message,
						answers: post.answers,
						timestamp: post.timestamp,
					});
				}

				if (needChange) {
					_arr.sort((a, b) => {
						if (
							typeof a.timestamp === 'undefined' ||
							typeof b.timestamp === 'undefined'
						) {
							return a.date > b.date ? 0 : 1;
						}
						if (a.timestamp < b.timestamp) {
							return 1;
						}
						if (a.timestamp > b.timestamp) {
							return -1;
						}
						return 0;
					});

					self.setState({ posts: _arr, deleteLoading: false });
				}
			});
		});
	}

	addPost(post) {
		this.props.firebase
			.newRoom('forums', this.props.event_id, 'posts', post)
			.then(function () {})
			.catch((err) => {
				console.error(err);
			});
	}
	onDeleteAnswer(postIdx, idx) {
		this.setState({ deleteLoading: true }, () => {
			const _arrPost = this.state.posts;
			_arrPost[postIdx].answers.splice(idx, 1);
			this.setState({ post: _arrPost, deleteLoading: false }, () => {
				const ans = this.props.firebase.getRoom(
					'forums',
					this.props.event_id,
					'posts',
					_arrPost[postIdx].id
				);

				this.props.firebase.updateDoc(ans, {
					answers: _arrPost[postIdx].answers,
				});
			});
		});
	}
	onDeletePost(post_id) {
		const self = this,
			_arrPost = this.state.posts,
			_post = _arrPost[post_id];

		this.props.firebase
			.deleteRoom('forums', this.props.event_id, 'posts', _post.id)
			.then(function () {
				self.props.firebase
					.newRoom('forums', self.props.event_id, 'deleted_posts', _post)
					.then(function () {})
					.catch((err) => {
						console.error(err);
					});
			})
			.catch((err) => {
				console.error(err);
			});
	}
	onNewAnswer(text, id) {
		const _arrPost = this.state.posts;
		_arrPost[id].answers.push({
			author: this.props.author.id,
			author_name: this.props.author.name,
			photoURL: this.props.author.photoURL,
			date: moment().format('YYYY-MM-DD HH:mm:ss'),
			message: text,
			timestamp: moment().unix(),
		});

		const ans = this.props.firebase.getRoom(
			'forums',
			this.props.event_id,
			'posts',
			_arrPost[id].id
		);

		this.props.firebase.updateDoc(ans, {
			answers: _arrPost[id].answers,
		});

		this.setState({ post: _arrPost });
	}
	onNewPost(text) {
		this.addPost({
			author: this.props.author.id,
			author_name: this.props.author.name,
			photoURL: this.props.author.photoURL,
			likes: 0,
			dislikes: 0,
			date: moment().format('YYYY-MM-DD HH:mm:ss Z'),
			message: text,
			timestamp: this.props.firebase.FIRESTORE_TIMESTAMP,
			answers: [],
		});
	}
	onReaction(newLikes, newDislikes, id) {
		const _arrPost = this.state.posts;
		const post = this.props.firebase.getRoom(
			'forums',
			this.props.event_id,
			'posts',
			_arrPost[id].id
		);

		this.props.firebase.updateDoc(post, {
			likes: newLikes,
			dislikes: newDislikes,
		});
	}
	render() {
		const { photoURL } = this.props.author;
		return (
			<React.Fragment>
				{this.props.author.id && (
					<ForumPost onSend={this.onNewPost} photoURL={photoURL} />
				)}
				<div className="Forum__body">
					{this.state.posts.map((post, idx) => {
						return (
							<ForumItem
								key={post.id}
								index={idx}
								deleteLoading={this.state.deleteLoading}
								onReaction={this.onReaction}
								onNewAnswer={this.onNewAnswer}
								onDeleteAnswer={this.onDeleteAnswer}
								onDeletePost={this.onDeletePost}
								owner={this.props.owner}
								user_id={this.props.author.id}
								photoURL={photoURL}
								post={post}
							/>
						);
					})}
				</div>
				{this.state.canGetMoreMessages && (
					<button
						onClick={this.getPosts}
						className="algo btn btn-link btn-block"
					>
						Ver mas
					</button>
				)}
			</React.Fragment>
		);
	}
}

export default Forum;
